import React from "react";
import RenderIcons from "../../../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";

const BillingInfomationHeaderAction = (props: { buttonText: string; setShowForm: any }) => {
    const { t: tLang } = useTranslation();

    return (
        <React.Fragment>
            <div className="box-actions">
                <button onClick={() => props.setShowForm(true)} type="button" className="btn-default btn-grey-dot" id="billing">
                    <span className="btn-text">
                        {props.buttonText} <span className="hide-mobile">{tLang("manageAccount.myAccount.billing.addNEditButtonText2")}</span>&nbsp;
                        <span className="btn-icon">
                            <RenderIcons iconName="pen" />
                        </span>
                    </span>
                </button>
            </div>
        </React.Fragment>
    );
};

export default BillingInfomationHeaderAction;
